<template>
  <div>
    <div class="owner_title">我的写手</div>
    <div class="filter_content">
      <div class="btn_box">
        <div class="btn_box_left">
          <el-button type="primary" @click="goOwnerInfo()" class="iconfont icon-jiahao addInfo">录入写手信息</el-button>
          <el-upload class="upload-demo" :action="uploadUrl" multiple :on-success="importXlsx" :show-file-list="false">
            <el-button type="primary" plain>
              <i class="el-icon-upload"></i>
              <span>导入信息</span>
            </el-button>
          </el-upload>
        </div>

        <div class="filtrate" @click="show_filter_form()">
          <i class="iconfont icon-shaixuan1"></i>
          <span>筛选</span>
        </div>
      </div>
      <!-- 筛选表单 -->
      <div class="filter_form" v-show="isFilterForm">
        <el-form ref="filter_form" :model="filter_form" :inline="true" class="demo-form-inline" label-width="100px">
          <el-form-item label="写手昵称" prop="nickname">
            <el-input v-model="filter_form.nickname"></el-input>
          </el-form-item>
          <el-form-item label="写手姓名" prop="name">
            <el-input v-model="filter_form.name"></el-input>
          </el-form-item>
          <el-form-item label="写手电话号码" prop="mobile">
            <el-input v-model="filter_form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="写手QQ">
            <el-input v-model="filter_form.qq_account"></el-input>
          </el-form-item>
          <el-form-item label="写手支付宝">
            <el-input v-model="filter_form.alipay_account"></el-input>
          </el-form-item>
          <el-form-item label="是否有任务">
            <el-select v-model="filter_form.is_task" placeholder="是否有任务">
              <el-option label="全部" value=""></el-option>
              <el-option label="无任务" value="0"></el-option>
              <el-option label="有任务" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker v-model="filter_form.createtime" value-format="yyyy-MM-dd" type="daterange"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="goSearch">搜索</el-button>
        </el-form>
      </div>
    </div>

    <!-- 表格数据 -->
    <el-table class="table_box" :data="dataShow" height="550" border style="width: 98%">
      <el-table-column type="index" label="序号" align="center" width="50">
      </el-table-column>
      <el-table-column property="nickname" label="写手昵称" align="center" sortable :width="equipmentType == 0 ? 180 : 101">
      </el-table-column>
      <el-table-column property="name" label="写手姓名" align="center" sortable :width="equipmentType == 0 ? 160 : 101">
      </el-table-column>
      <el-table-column property="mobile" label="写手电话号码" align="center" sortable :width="equipmentType == 0 ? 160 : 130">
      </el-table-column>
      <el-table-column property="qq_account" label="写手QQ" align="center" sortable :width="equipmentType == 0 ? 140 : 101">
      </el-table-column>
      <el-table-column property="alipay_account" label="写手支付宝" align="center" sortable
        :width="equipmentType == 0 ? 160 : 120"></el-table-column>
      <el-table-column property="press_draft_money" label="未结算压稿金额" align="center" sortable width="160">
      </el-table-column>
      <el-table-column property="temporary_money" label="暂压稿费" align="center" sortable
        :width="equipmentType == 0 ? 130 : 110">
      </el-table-column>
      <el-table-column property="deposit_money" label="压稿" align="center" sortable :width="equipmentType == 0 ? 160 : 90">
      </el-table-column>
      <el-table-column label="写手标签" align="center" sortable :width="equipmentType == 0 ? 140 : 110">
        <template slot-scope="scope">
          <el-tag :key="item" v-for="item in scope.row.connectionlabel_text" type="info">{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column property="connectionremark_text" label="批注" align="center" sortable
        :width="equipmentType == 0 ? 130 : 90">
      </el-table-column>
      <el-table-column property="is_high_seas" label="是否由公海转入" align="center" sortable width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_high_seas == '0' ? 'info' : 'success'">
            {{ scope.row.is_high_seas == "0" ? "否" : "是" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column property="is_task" label="是否有任务" align="center" sortable width="130">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_task == '0' ? 'info' : 'success'">
            {{ scope.row.is_task == "0" ? "无任务" : "有任务" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column property="createtime" label="创建时间" align="center" sortable :width="equipmentType == 0 ? 180 : 110">
      </el-table-column>
      <el-table-column label="操作" align="center" width="360" :fixed="equipmentType == 1 ? false : 'right'">
        <template slot-scope="scope">
          <div class="control_btn_box">
            <div @click="initMoney(scope.row)" class="apply_btn">
              <i class="el-icon-circle-plus-outline"></i>
              初始压稿申请
            </div>
            <div @click="writerEdit(scope.row)" class="edit_btn">
              <i class="el-icon-edit-outline"></i>
              修改
            </div>
            <div @click="addLabel(scope.row)" class="edit_btn">
              <i class="el-icon-circle-plus-outline"></i>
              标签
            </div>
            <div @click="addRemarkDialog(scope.row)" class="edit_btn">
              <i class="el-icon-circle-plus-outline"></i>
              批注
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 初始压稿申请 -->
    <el-dialog title="初始压稿申请" :visible.sync="moneyDialogVisible" :width="dialogWidth" center>
      <el-form :model="moneyForm" ref="moneyForm">
        <el-form-item label="压稿金额:" prop="money">
          <el-input v-model="moneyForm.money" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog_btn" round type="primary" @click="handleSetMoney()">确认添加</el-button>
        <el-button class="dialog_btn" round @click="moneyDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 添加标签弹窗 -->
    <el-dialog title="添加标签" :visible.sync="tagDialogVisible" :width="dialogWidth" center>
      <el-form :model="tagForm" :rules="rules">
        <el-form-item label="添加标签:">
          <el-checkbox-group class="checkbox" v-model="checkedLabels">
            <el-checkbox @change="handleCheckedLabel(item)" class="checkbox" v-for="item in lableList" :key="item.name"
              :label="item.name">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog_btn" round type="primary" @click="handleAdd">确认添加</el-button>
        <el-button class="dialog_btn" round @click="tagDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 添加批注弹窗 -->
    <el-dialog title="添加批注" :visible.sync="remarkDialogVisible" :width="dialogWidth" center>
      <el-form :model="remarkForm" ref="remarkForm">
        <el-form-item label="添加批注:" prop="connectionremark">
          <el-input v-model="remarkForm.connectionremark" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog_btn" round type="primary" @click="handleSetRemark()">确认添加</el-button>
        <el-button class="dialog_btn" round @click="remarkDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-pagination v-show="equipmentType == 0 ? true : false" class="pagination_box" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <el-pagination v-show="equipmentType == 1 ? true : false" class="pagination_box" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize" layout="total, prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>
<script>
import {
  writer_tabulation,
  add_connectionremark,
  label_tabulation,
  add_label,
  initial_press_release_apply
} from "@/utils/writer";
import { import_xlsx } from "@/utils/api";
let previousRouterName = "";
let filter_obj = "";
let cancel_tag = "";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl, //文件上传路径
      writerList: [], //写手列表
      writerId: "", //所需写手部门id
      isFilterForm: true, //筛选表单
      tagDialogVisible: false, //标签弹窗
      remarkDialogVisible: false, //批注弹窗
      moneyDialogVisible: false, //初始压稿申请弹窗
      dialogWidth: "30%", //弹窗宽度
      rules: {
        labels: [{ required: true, message: "请选择标签", trigger: "blur" }]
      },
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        nickname: "", //写手昵称
        name: "", //写手姓名
        mobile: "", //写手电话号码
        qq_account: "", //写手QQ
        alipay_account: "", //写手支付宝
        createtime: "", //创建时间范围
        is_task: "", //是否有任务:0=无任务,1=有任务  默认空
        equipmentType: 0 //设备 0-pc端 1移动端
      },
      // 批注表单
      remarkForm: {
        departmentuser_id: "",
        writer_id: "",
        connectionremark: ""
      },
      // 标签表单
      tagForm: {
        departmentuser_id: "",
        writer_id: "",
        connectionlabel_ids: ""
      },
      // 初始压稿申请表单
      moneyForm: {
        departmentuser_id: "",
        writer_expand_id: "",
        money: ""
      },
      initPressMoney: "", //初始金额
      lableList: "", //标签列表
      checkedLabels: [], //选择的标签
      selectLabelList: [], //选中标签值的列表
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  beforeRouteEnter(to, from, next) {
    previousRouterName = from.path;
    cancel_tag = from.params.edit_id;
    if (from.path === "/writerEdit") {
      if (from.params.edit_id == 1) {
        filter_obj = JSON.stringify(from.params.filter);
      } else {
        filter_obj = JSON.stringify(from.params.filter);
      }
      console.log("跳转参数", filter_obj);
    }
    next();
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
      this.dialogWidth = "70%";
    } else {
      this.equipmentType = 0;
      this.dialogWidth = "30%";
    }
    if (previousRouterName === "/writerEdit") {
      console.log("cancel_tag", cancel_tag);

      var that = this;
      var obj_data = JSON.parse(filter_obj);
      let obj;
      if (cancel_tag == 1) {
        // 直接取消
        obj = {
          departmentuser_id: this.writerId,
          ...obj_data
        };
      } else {
        if (obj_data.createtime == "") {
          obj = {
            departmentuser_id: this.writerId,
            ...obj_data
          };
        } else {
          var createTimeData =
            obj_data.createtime[0] + " - " + obj_data.createtime[1];
          this.filter_form = obj_data;
          obj = {
            departmentuser_id: this.writerId,
            ...obj_data,
            createtime: createTimeData
          };
        }
      }
      writer_tabulation(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.writerList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    } else {
      this.getWriterList();
    }
  },

  methods: {
    // 获取写手列表
    getWriterList() {
      var that = this;
      // this.filter_form.createtime = "2023-06-01 - 2023-06-19";
      let obj = {
        departmentuser_id: that.writerId
      };
      writer_tabulation(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.writerList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 写手信息导入
    importXlsx(val) {
      var that = this;
      let obj = {
        file: val.data.url
      };
      import_xlsx(obj).then(res => {
        if (res.data.code == 1) {
          that.getWriterList();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 初始压稿金额
    initMoney(val) {
      var that = this;
      that.initPressMoney = val.initial_press_release;
      that.moneyDialogVisible = true;
      that.moneyForm = { ...val };
    },
    // 提交初始压稿金额
    handleSetMoney() {
      var that = this;
      var current_money = that.moneyForm.money;
      if (parseFloat(current_money) > that.moneyForm.initial_press_release) {
        that.$message.error(
          "初始压稿金额不能超过" + that.moneyForm.initial_press_release
        );
        that.moneyDialogVisible = false;
      } else {
        let obj = {
          departmentuser_id: that.writerId,
          writer_expand_id: that.moneyForm.writer_expand_id,
          money: current_money
        };
        initial_press_release_apply(obj).then(res => {
          if (res.data.code == 1) {
            that.$message.success(res.data.msg);
            that.moneyDialogVisible = false;
            that.goSearch();
            // that.getWriterList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }
    },
    // 打开批注弹窗
    addRemarkDialog(row) {
      var that = this;
      that.remarkDialogVisible = true;
      that.remarkForm = { ...row };
    },
    // 确认添加批注
    handleSetRemark() {
      var that = this;
      var currentId = that.remarkForm.id;
      let obj = {
        departmentuser_id: that.writerId,
        writer_id: currentId,
        connectionremark: that.remarkForm.connectionremark
      };
      add_connectionremark(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          that.remarkDialogVisible = false;
          that.goSearch();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    //打开弹窗获取标签列表
    addLabel(val) {
      var that = this;
      that.tagForm.writer_id = val.id;
      that.tagDialogVisible = true;
      that.getLabelList();
      //初始化选中标签id，名字
      let labelsId = [];
      if (val.connectionlabel_ids != null) {
        labelsId = val.connectionlabel_ids.split(",");
      }
      let labelsName = [];
      Object.values(that.lableList).forEach(item => {
        if (labelsId.includes(String(item.id))) {
          labelsName.push(item.name);
        }
      });
      that.checkedLabels = labelsName;
      that.selectLabelList = labelsId;
    },
    // 获取标签列表
    getLabelList() {
      var that = this;
      label_tabulation().then(res => {
        if (res.data.code == 1) {
          that.lableList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 选中标签
    handleCheckedLabel(val) {
      var that = this;
      let _id = String(val.id);
      if (that.selectLabelList.includes(_id)) {
        that.selectLabelList = that.selectLabelList.filter(item => item != _id);
      } else {
        that.selectLabelList.push(_id);
      }
      that.tagForm.connectionlabel_ids = that.selectLabelList.join(",");
    },
    // 确认添加标签
    handleAdd() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        writer_id: that.tagForm.writer_id,
        connectionlabel_ids: that.tagForm.connectionlabel_ids
      };
      add_label(obj).then(res => {
        if (res.data.code == 1) {
          that.tagDialogVisible = false;
          that.goSearch();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 修改写手信息
    writerEdit(val) {
      var that = this;
      let data = JSON.stringify(val);
      let filter = JSON.stringify(this.filter_form);
      that.$router.push("/writerEdit?data=" + data + "&filter=" + filter);
    },

    // 筛选
    goSearch(val) {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (val == 0) {
        var time1, time2;
        time1 = that.select_time_data[0];
        time2 = that.select_time_data[1];
        that.time_filter = time1 + " - " + time2;
        that.filter_form.createtime = that.time_filter;
      } else {
        if (date1 == undefined && date2 == undefined) {
          that.time_filter = "";
        } else {
          that.time_filter = date1 + " - " + date2;
        }
        console.log("that.time_filter", that.time_filter);
        that.filter_form.createtime = that.time_filter;
      }
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10,
        ...that.filter_form
      };
      writer_tabulation(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.writerList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 录入金主信息
    goOwnerInfo() {
      var that = this;
      that.$router.push("/writerInfo");
    },
    // 计算页数的方法
    calcPageData() {
      // 计算页数，根据后台数据的条数和每页要显示的数量算出一共多少页，得0时设为1
      if (this.writerList.length > 1) {
        this.pageNum = Math.ceil(this.writerList.length / this.pageSize) || 1;
      }
      //数据分组
      for (let i = 0; i < this.pageNum; i++) {
        // 根据每页显示数量，将后台的数据分割到每一页，假设pageSize为5，则第一也为1-5条slice(0,5),slice(5,10)...
        this.totalPageData[i] = this.writerList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }

      // 获取到数据后显示第一页内容，数组下标是从0开始的，这里一定 要减去1，不然会丢失一组数据
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // 重新计算页数并分组
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // 注意数组是从0开始，页码别忘了减去1
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.filter_content {
  /* border: 1px solid black; */
}

.el-input__inner {
  background-color: RGB(250, 250, 250);
}

.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}

.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.btn_box_left {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* 筛选表单 */
.filter_form {
  background: #ffffff;
  margin: 0px 16px;
  padding: 15px 0px;
}

.filter_form .el-input__inner {
  background-color: RGB(250, 250, 250) !important;
  border: 1px solid #dcdfe6 !important;
}

.btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 10px 15px;
}

.addInfo {
  margin-right: 15px;
}

.addInfo,
.filtrate i {
  font-size: 14px;
}

.filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}

.table_box {
  margin: 0px 15px;
}

.table_box .el-tag {
  width: 90px;
  margin: 5px auto;
}

.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}

.tag_circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e2170f;
  margin-right: 5px;
}

.btn {
  width: 77px;
  height: 20px;
  text-align: center;
  line-height: 5px;
  background: #157df8;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}

.el-dialog__header {
  background: #157df8;
}

.el-dialog__title {
  color: #fff;
}

.el-dialog--center .el-dialog__body {
  padding: 25px 70px 30px;
}

.dialog-footer .dialog_btn {
  width: 200px;
  height: 35px;
}

@media screen and (max-width: 750px) and (min-width: 375px) {
  .dialog-footer .dialog_btn {
    width: 100px;
    height: 35px;
  }
}

.checkbox {
  display: flex;
  flex-direction: column;
}

.edit_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  margin-right: 5px;
  cursor: pointer;
}

.apply_btn {
  width: 150px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  margin-right: 5px;
  cursor: pointer;
}

.control_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.checkbox {
  display: table-row-group;
}

@media screen and (max-width: 750px) and (min-width: 375px) {
  .table_box {
    margin-bottom: 150px;
  }
}

.el-select-dropdown {
  position: absolute !important;
  top: 30px !important;
  left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/writer/MyWriter.vue